import { PageLayout, type BreadcrumbItemData } from '@/components/layout/PageLayout';
import { PageHero } from '@/components/ui/page-hero';
import type { EditMenuBypass } from '@/contexts/PageChromeContext';
import type { ReactNode } from 'react';

export interface PillarTabbedPageProps {
  breadcrumbItems: BreadcrumbItemData[];
  actions?: ReactNode;
  editMenuExtension?: ReactNode;
  editMenuBypass?: EditMenuBypass | null;
  hero: {
    avatar?: ReactNode;
    title: ReactNode;
    subtitle?: ReactNode;
  };
  tabs: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  /** Registers header chrome only (e.g. PlanningPlanBreadcrumb). */
  chromeExtras?: ReactNode;
  trailing?: ReactNode;
}

/**
 * Shared pillar hub layout: PageLayout chrome → PageHero → route tabs → tab content.
 */
export function PillarTabbedPage({
  breadcrumbItems,
  actions,
  editMenuExtension,
  editMenuBypass,
  hero,
  tabs,
  children,
  footer,
  chromeExtras,
  trailing,
}: PillarTabbedPageProps) {
  return (
    <PageLayout
      breadcrumbItems={breadcrumbItems}
      actions={actions}
      editMenuExtension={editMenuExtension}
      editMenuBypass={editMenuBypass}
    >
      {chromeExtras}
      <div className='flex flex-col gap-4'>
        <PageHero avatar={hero.avatar} title={hero.title} subtitle={hero.subtitle} />
        {tabs}
        {children}
        {footer}
      </div>
      {trailing}
    </PageLayout>
  );
}
